import { ShopRendererThemesApiClient } from '@fourthwall/services/dist/ShopRendererThemesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useThemeLibraryQuery = createQueryHook(ShopRendererThemesApiClient.getThemeLibrary, {
  queryKey: ['themeLibrary'],
})
